module.exports = __webpack_public_path__ + "static/media/general.f222e998.svg";